export default __webpack_public_path__ + "static/media/audience.521013c3.png";